import { ReactNode, MouseEventHandler, HTMLAttributes } from "react";
import { cn } from "@drpcrd/utils/shared";

type CardWrapperProps = HTMLAttributes<HTMLDivElement> & {
  children: [ReactNode, ReactNode];
  onClick?: MouseEventHandler<HTMLDivElement>;
  className?: string;
};

export const CardWrapper = ({
  children,
  onClick,
  className,
}: CardWrapperProps) => {
  const [mainContent, footerContent] = children;
  return (
    <div
      className={cn(
        "hover:shadow-light group flex flex-col justify-between overflow-hidden rounded-2xl border border-neutral-500 bg-white transition-all duration-100 hover:border-neutral-900",
        className,
      )}
      onClick={onClick}
    >
      <div>{mainContent}</div>
      <div>{footerContent}</div>
    </div>
  );
};
